<template>
    <div class="bg-blue-bright">
        <Mainlayout></Mainlayout>
        <CCol sm="12" style="background-size: cover; color: #fff;background: #007cef;">
    
            <CCol sm="12" lg="12" style="width: 60%;background-size: cover; margin: auto;color: #fff">
                <CRow>
                    <CCol sm="12" lg="12">
                        <div style="margin-top:15%">
                            <CCard>
                                <div class="text-center mt-5">
                            <img style="max-width:100px" src="../assets/img/avatar.png" />
                        </div>
                            <br />
                           
                            <CCol sm="12" lg="12" style="width: 60%;background-size: cover; margin: auto;color: #fff">
                                <CRow>
                                    <CCol sm="6">
                                        <h3 class="custom-14px text-left">First Name</h3>
                                        <CInput type="text" class="custom-input b-50" />
                                        
                                    </CCol>
                                    <CCol sm="6">
                                        <h3 class="custom-14px">Last Name</h3>
                                        <CInput type="text" class="custom-input b-50" />
                                    </CCol>

                                    <CCol sm="12">
                                        <h3 class="custom-14px text-left">Phone Number</h3>
                                        <CInput type="text" class="custom-input b-50" />
                                        
                                    </CCol>
                                    <CCol sm="12">
                                        <h3 class="custom-14px">Age</h3>
                                        <CInput type="text" class="custom-input b-50" />
                                    </CCol>
                                    <CCol sm="12">
                                        <h3 class="custom-14px">Email Address</h3>
                                        <CInput type="text" class="custom-input b-50" />
                                    </CCol>
                                    <CCol sm="12">
                                        <h3 class="custom-14px">Course</h3>
                                        <CInput type="text" class="custom-input b-50" />
                                    </CCol>
                                    <CCol sm="12">
                                        <h3 class="custom-14px">I’am Interested With This Course</h3>
                                        <CTextarea type="text"
                rows="9"/>
                                    </CCol>
                                    <CButton type="button" class="bg-button-blue text-white" block>Register</CButton>
                               
                                   
                                </CRow>
                                <br /><br />
                            </CCol>
                        </CCard>
                        <br /><br />
                        </div>
                    </CCol>
    
    
    
                </CRow>
            </CCol>
        </CCol>
    
    </div>
</template>

<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bg.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";


export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout
    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundMap

        };
    },
    created() {
        AOS.init();
    },
    methods: {
        GoToTraining() {
            this.$router.push("TrainingClass");
        }
    }

};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat');
body {
    top: 0 !important;
    font-family: 'Montserrat', sans-serif;
}

.custom-tab .nav-link.active {
    border-bottom: 2px solid #000;
    /* Replace with your desired border color */
}
</style>